import { useTranslation } from "@impero-com/common/utils/i18n";
import { RateGauge } from "@impero-com/ui";

import * as theme from "./ControlHealthDonutRateWidget.css";
import { ControlHealthWidget } from "./ControlHealthWidget";

interface ControlHealthCompletionRateWidgetProps {
    completionRate: number | null;
}

export function ControlHealthCompletionRateWidget({
    completionRate,
}: ControlHealthCompletionRateWidgetProps) {
    const { t } = useTranslation();
    const percentage =
        completionRate === null ? null : Math.round(completionRate * 10) / 10;

    return (
        <ControlHealthWidget
            title={t("ControlHealth_CompletionRate_Label")}
            className={theme.card}
        >
            <RateGauge
                percentage={percentage}
                label={t("ControlHealth_CompletionRate_Label")}
            />
        </ControlHealthWidget>
    );
}
